import API from '@/views/Fdc/Apis/'

/**
 * ModelRuleGrid : 선택한 summary data plan의 SPC 룰 조건 조회 그리드
 */
export default {
  name: 'ModelRuleGrid',
  props: {
    modelRowData: {
    }
  },
  beforeMount () {
    this.initModelRuleColumns()
  },
  mounted () {
    this.getEmailGroupList()
    this.getFaultLevelList()
  },
  watch: {
    rowData: function () {
      this.updateComboBoxInGrid()
    },
    modelRowData: function () {
      let data = this.modelRowData
      // if (data === null || data._status.added) {
      if (data === null ||
      (data.briqueGridCud && data.briqueGridCud === 'C')) {
        this.rowData = []
        this.originRowData = []
      } else if (Object.keys(data).length === 0) {
        this.rowData = []
        this.originRowData = []
      } else {
        this.listFn(data)
      }
    }
  },
  methods: {
    initModelRuleColumns () {
      this.columns = [
        { headerName: this.$t('fdc.SPC.COLUMN.RULE_USE_YN'), field: 'useYn', hide: true },
        { headerName: this.$t('fdc.SPC.COLUMN.RULE_NO'), field: 'ruleNo', width: 80, required: true, editable: false, checkboxSelection: true, headerCheckboxSelection: true },
        { headerName: this.$t('fdc.SPC.COLUMN.FAULT_LEVEL'), field: 'faultLevel', width: 110, required: true, editable: true },
        {
          headerName: this.$t('fdc.SPC.COLUMN.EMAIL_YN'),
          field: 'emailYnCheckbox',
          width: 100,
          required: true,
          type: 'checkboxColumn',
          dataMapping: {
            key: 'emailYn',
            true: 'Y',
            false: 'N'
          }
        },
        { headerName: this.$t('fdc.SPC.COLUMN.EMAIL_YN'), field: 'emailYn', width: 80, editable: false, hide: true },
        {
          headerName: this.$t('fdc.SPC.COLUMN.INTERLOCK_YN'),
          field: 'interlockYnCheckbox',
          width: 100,
          required: true,
          type: 'checkboxColumn',
          dataMapping: {
            key: 'interlockYn',
            true: 'Y',
            false: 'N'
          }
        },
        { headerName: this.$t('fdc.SPC.COLUMN.INTERLOCK_YN'), field: 'interlockYn', width: 80, editable: false, hide: true },
        { headerName: this.$t('fdc.SPC.COLUMN.EMAIL_GROUP_ID'), field: 'emailGroupId', width: 120, required: true, editable: true },
        { headerName: this.$t('fdc.SPC.COLUMN.RULE_DESC'), field: 'ruleDesc', width: 320, required: true, editable: false },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), field: 'modifyUser', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), field: 'modifyDt', width: 150, type: 'dateTimeColumn' }
      ]
    },
    /**
     * SPC Rules Grid column에 data map 설정
     */
    updateComboBoxInGrid () {
      this.columns.map(c => {
        if (c.field === 'emailGroupId') {
          c.cellEditor = 'agSelectCellEditor'
          c.cellEditorParams = {
            values: this.emailGroupId
          }
        } else if (c.field === 'faultLevel') {
          c.cellEditor = 'agSelectCellEditor'
          c.cellEditorParams = {
            values: this.faultLevel
          }
        }

        return c
      })
      this.$refs.modelRuleGrd.gridApi.setColumnDefs(this.columns)
    },
    /**
     * Email Group List Data Mapping
     */
    async getEmailGroupList () {
      this.emailGroupId.push('UNDEFINED')
      let result = await API.Model.getSpcMailGroups()
      result.map(data => this.emailGroupId.push(data.emailGroupId))
    },
    /**
     * Fault Level Data Mapping
     */
    async getFaultLevelList () {
      let self = this

      self.faultLevel.push('UNDEFINED')

      let payload = { codeType: 'FAULT_LEVEL' }
      await API.Common.getCodes(payload, callback, null)

      function callback (response) {
        if (response.status === 200 && response.data) {
          response.data.map(data => self.faultLevel.push(data.codeName))
        }
      }
    },
    async listFn (paramData) {
      // this.rowData = []
      // Rule 조회

      // 조회 input 기본 data
      const payload = {
        fab: paramData.fab,
        eqpId: paramData.eqpId,
        moduleId: paramData.moduleId,
        paramName: paramData.paramName,
        recipeId: paramData.recipeId,
        stepId: paramData.stepId,
        smryType: paramData.smryType,
        lotStepYn: paramData.lotStepYn
      }

      // Rule 조회 API 호출
      let data = await API.Model.getSpcModelRules(payload)
      data = data.map(item => {
        const _item = { ...item, useYnCheckbox: null, emailYnCheckbox: null, interlockYnCheckbox: null, initDone: true }
        if (item.useYn === 'Y') {
          _item.initDone = false
          _item.useYnCheckbox = true
        } else {
          _item.useYnCheckbox = false
        }

        if (item.emailYn === 'Y') {
          _item.emailYnCheckbox = true
        } else {
          _item.emailYnCheckbox = false
        }

        if (item.interlockYn === 'Y') {
          _item.interlockYnCheckbox = true
        } else {
          _item.interlockYnCheckbox = false
        }

        return _item
      })
      console.log({ data })
      this.rowData = data
      this.originRowData = data

      // 조회한 모델 룰 데이터 메인화면으로 내보내기 (Simulation에 사용)
      // this.$emit('selected-model-rules', this.rowData)

      // this.modelRuleGrd.select(-1, -1)
    },

    onCellClick (params) {
      if (params.column.colId === 'interlockYnCheckbox' || params.column.colId === 'emailYnCheckbox') {
        const currentSelected = params.node.selected
        if (currentSelected) {
          // Don nothing
        } else {
          params.node.setSelected(true)
        }
      } else {
        const currentSelected = params.node.selected
        params.node.setSelected(!currentSelected)
      }
    },

    onRowSelected (params) {
      if (params.data.initDone === false) {
        // Do nothing - initialize on progress
        // NOTE: CheckboxColumn -> Grid Selection 변경 하여 초기 렌더링 될 때 briqueGridCud 값으로 CSS 스타일이 적용되는걸 막기 위함
        params.data.initDone = true
        params.node.setData(params.data)
      } else if (params.data.initDone === true) {
        params.data.briqueGridCud = 'U'
        params.node.setData(params.data)
      }
    },

    onRowDataChanged (params) {
      if (this.rowData.length > 0) {
        const gridApi = params.api
        const model = gridApi.getModel()
        const rowCount = model.getRowCount()
        for (let i = 0; i < rowCount; i++) {
          const node = model.getRow(i)
          if (node) {
            let { useYn } = node.data
            if (useYn === 'Y') {
              node.setSelected(true)
            }
          }
        }
      }
    },
    // 데이터 저장
    /**
     * useYn = 'Y'인 경우 모두 SAVE or UPDATE하고,
     * useYn = 'N'인 경우 모두 DELETE한다
     * (API에 수정한 데이터 row 전체 넘김)
     */
    saveData () {
      let self = this
      if (this.saveValidation()) {
        return
      }

      let yRules = []
      // this.rowData.map(d => { if (d.useYn === 'Y') yRules.push(d.ruleNo) })
      this.rowData.map(d => { if (d.useYn) yRules.push(d.ruleNo) })

      if (yRules.length === 0) {
      // 저장 확인 창
        let confirmMessage = ''
        confirmMessage += this.$t('fdc.SPC.MESSAGE.RULE_SAVE_VALIDATION')

        this.$dialog.confirm({
          message: confirmMessage,
          confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
          cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
          onConfirm: () => {
            this.$emit('model-row-empty', 'N')
            saveProcess()
          },
          onCancel: () => {
          }
        })
      } else {
        saveProcess()
      }

      function saveProcess () {
        const allRows = self.$refs.modelRuleGrd.getAllRows()
        let saveRows = []
        let deleteRows = []

        allRows.some(row => {
          const item = _.clone(row)
          if ((item.briqueGridSelected === 'true' && item.useYn === 'N')) { // 새로 추가될 항목
            if (item['emailYn'] === null) item['emailYn'] = 'N'
            if (item['interlockYn'] === null) item['interlockYn'] = 'N'

            item['fab'] = self.modelRowData.fab
            item['eqpId'] = self.modelRowData.eqpId
            item['moduleId'] = self.modelRowData.moduleId
            item['paramName'] = self.modelRowData.paramName
            item['recipeId'] = self.modelRowData.recipeId
            item['stepId'] = self.modelRowData.stepId
            item['smryType'] = self.modelRowData.smryType
            item['lotStepYn'] = self.modelRowData.lotStepYn
            item['modifyDt'] = new Date(item.modifyDt)
            item['useYn'] = 'Y'

            if (item['emailGroupId'] === 'UNDEFINED') item['emailGroupId'] = null

            // 로그인 기능이 없어 사용자 정보 없으므로 modifyUser 하드코딩
            item['createUser'] = 'brique'
            item['modifyUser'] = 'brique'

            saveRows.push(item)
          } else if (item.briqueGridSelected === 'false') { // 삭제될 항목
            if (item['emailYn'] === null) item['emailYn'] = 'N'
            if (item['interlockYn'] === null) item['interlockYn'] = 'N'

            item['fab'] = self.modelRowData.fab
            item['eqpId'] = self.modelRowData.eqpId
            item['moduleId'] = self.modelRowData.moduleId
            item['paramName'] = self.modelRowData.paramName
            item['recipeId'] = self.modelRowData.recipeId
            item['stepId'] = self.modelRowData.stepId
            item['smryType'] = self.modelRowData.smryType
            item['lotStepYn'] = self.modelRowData.lotStepYn
            item['modifyDt'] = new Date(item.modifyDt)
            item['useYn'] = 'N'

            // 로그인 기능이 없어 사용자 정보 없으므로 modifyUser 하드코딩
            item['createUser'] = 'brique'
            item['modifyUser'] = 'brique'

            deleteRows.push(item)
          } else if (row.briqueGridCud && row.briqueGridCud === 'U') { // 업데이트만 된 항목
            if (item['emailYn'] === null) item['emailYn'] = 'N'
            if (item['interlockYn'] === null) item['interlockYn'] = 'N'

            item['fab'] = self.modelRowData.fab
            item['eqpId'] = self.modelRowData.eqpId
            item['moduleId'] = self.modelRowData.moduleId
            item['paramName'] = self.modelRowData.paramName
            item['recipeId'] = self.modelRowData.recipeId
            item['stepId'] = self.modelRowData.stepId
            item['smryType'] = self.modelRowData.smryType
            item['lotStepYn'] = self.modelRowData.lotStepYn
            item['modifyDt'] = new Date(item.modifyDt)
            item['useYn'] = 'Y'

            if (item['emailGroupId'] === 'UNDEFINED') item['emailGroupId'] = null

            // 로그인 기능이 없어 사용자 정보 없으므로 modifyUser 하드코딩
            item['createUser'] = 'brique'
            item['modifyUser'] = 'brique'

            saveRows.push(item)
          }
        })

        // useYn = 'N'인 대상 삭제
        let payloadDelete = deleteRows

        if (payloadDelete.length > 0) {
          API.Model.deleteSpcModelRules(payloadDelete).then(response => {
            if (response.status === 200) {
              self.$buefy.toast.open({
                message: self.$t('fdc.SPC.MESSAGE.UNUSED_SPC_RULE_SAVED'),
                // type: 'is-success',
                queue: false // queue: false => toast가 2개 이상일 때 같은 영역에 덮어쓰지 않고, 최신것이 위에 표시되게 하는 방식
              })
              self.refreshData()
            }
          })
        }

        // useYn = 'Y'인 대상 insert / update
        let payload = saveRows

        if (payload.length > 0) {
          API.Model.saveSpcModelRules(payload).then(async response => {
            if (response.status === 200) {
              self.$buefy.toast.open({
                message: self.$t('fdc.SPC.MESSAGE.SPC_RULE_SAVED'),
                // type: 'is-success',
                queue: false // queue: false => toast가 2개 이상일 때 같은 영역에 덮어쓰지 않고, 최신것이 위에 표시되게 하는 방식
              })
              self.refreshData()
            }
          })
        }
      }
    },

    // 저장 데이터 Validation
    saveValidation () {
      let modelRuleGrid = this.$refs.modelRuleGrd
      // const allRows = this.modelRuleGrd.collectionView.items
      // const checkedRows = allRows.filter(d => d._status.modified)
      const checkedRows = modelRuleGrid.getCheckedRows()
      const that = this
      return checkedRows.some(row => {
        const checkRequired = Object.keys(row).some(function (itemKey) {
          // const column = modelRuleGrid.columns.getColumn(itemKey)
          let column = null
          modelRuleGrid.columns.forEach(c => {
            if (c['field'] === itemKey) {
              column = c
              return false
            }
          })
          const colValue = row[itemKey]
          if (column !== null) {
            switch (column.binding) {
              case 'faultLevel':
                if (that.isEmpty(colValue) && row['useYn'] === 'Y') {
                  that.$dialog.alert(that.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Fault Level']))
                  return true
                }
                break

              case 'emailGroupId':
                if (that.isEmpty(colValue) && row['emailYn'] === 'Y') {
                  that.$dialog.alert(that.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Email Group Id']))
                  return true
                }
                break
              default:
                if (that.isEmpty(colValue) && column.binding === 'emailGroupId') {
                  that.$dialog.alert(that.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', [column.header]))
                  return true
                }
                break
            }
          }
        })
        // 필수값
        if (checkRequired) { return true }
      })
    },

    hasModelRow () {
      if (this.modelRowData === null) {
        return false
      } else if (Object.keys(this.modelRowData).length === 0) {
        return false
      // } else if (  ) {
      } else if (this.modelRowData.briqueGridCud && this.modelRowData.briqueGridCud === 'C') {
        return false
      } else {
        return true
      }
    },

    // // 데이터 있는 경우에만 버튼 활성화
    // hasCheckedRows () {
    //   if (!this.$refs.modelRuleGrd) {
    //     return 0
    //   }
    //   return this.$refs.modelRuleGrd.checkedRowCount > 0
    // },
    // /**
    //  * Row Selected
    //  * @param {*} grid
    //  * @param {*} event
    //  */
    // selectedRow (grid, event) {
    //   if (grid.selectedItems.length === 1 && !grid.selectedItems[0]._status.added) {
    //     this.$emit('model-row-selected', grid.selectedItems[0])
    //   } else {
    //     this.$emit('model-row-selected', null)
    //   }
    // },
    // 새로고침
    refreshData () {
      this.listFn(this.modelRowData)
    },
    /**
     * null 값 check
     */
    isEmpty (value) {
      if (value === '' || value == null || value === undefined || (value != null && typeof value === 'object' && !Object.keys(value).length)) {
        return true
      } else {
        return false
      }
    },
    getRules () {
      let yRules = []
      this.rowData.map(data => {
        // if (data.useYn === 'Y') yRules.push(data.ruleNo)
        if (data.useYn) yRules.push(data.ruleNo)
      })
      return yRules
    }

  },
  data () {
    return {
      columns: [],
      defaultColDef: {
        minWidth: 100,
        filter: true,
        sortable: true,
        resizable: true
      }, // BRIQUE Grid column default setting
      rowData: [],
      originRowData: [],
      maxCondSeq: null,
      emailGroupId: [],
      faultLevel: []
    }
  }
}
